import React from "react";
import { InputNumber } from "antd";

const MoneyInput = ({ placeholder, ...props }) => (
  <InputNumber
    precision={2}
    step={0.01}
    min={0}
    suffix="บาท"
    formatter={(value) => {
      if (!value && value !== 0) return "";
      const parts = value.toString().split(".");
      const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      const decimalPart = parts[1] || "00";
      return `${integerPart}.${decimalPart.padEnd(2, "0")}`;
    }}
    parser={(value) => value?.replace(/,/g, "") || ""}
    size="large"
    placeholder={placeholder || "กรอกจำนวนเงิน"}
    style={{ width: "100%", color: "black" }}
    {...props}
  />
);

export default MoneyInput;
